export default "__VITE_ASSET__51a209de__"